module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm_title"
  }, [_vm._v("GLOSSARY")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Abbreviations:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cz = Czech, D = Dutch, Da = Danish, F = French, Fin = Finnish, Fl = Flemish, G = German, Hun = Hungarian (Magyar), It = Italian, Nor = Norwegian, Pol = Polish, Rom = Romanian, Ru = Russian, Slov = Slovene, Sp = Spanish, Sw = Swedish")]), _vm._v(" "), _c('p', {
    staticClass: "gloss-t"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Aangehechect Reversecaponniere")]), _vm._v(" (D/Fl) – attached (connected to the fort) reverse caponier")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Abri")]), _vm._v(" (F) – shelter")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Abrigo")]), _vm._v(" (Sp) – shelter, abri")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Acciaio")]), _vm._v(" (It) – steel")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Acero")]), _vm._v(" (Sp) – steel")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Acier")]), _vm._v(" (F) – steel")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Acqua potabile")]), _vm._v(" (It) – drinking water")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Adápost")]), _vm._v(" (Rom) – shelter")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Affusto")]), _vm._v(" (It) – gun carriage")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Aknamezö")]), _vm._v(" (Hun) – minefield")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ametralladora")]), _vm._v(" (Sp) – machine gun")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ammus")]), _vm._v(" (Fin) – Projectile or shell")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Anlage/Stand")]), _vm._v(" (G) – bunker, also any type of structure")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Anti-Char")]), _vm._v(" (F) – anti-tank")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Anti-Ricochet Device")]), _vm._v(" – the anti-ricochet device is an embrasure that does not flare outward with smooth sides. Instead, its sides form a series of steps that lead to the inner part of the embrasure so that if a shell hits, one of the ‘steps’ can deflect it. Made of concrete or of armour")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Anti-tank, AT")]), _vm._v(" – weapons or obstacles to stop armoured vehicles")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Apostamento")]), _vm._v(" (It) – defensive shelter, natural or artificial, behind which lie isolated men or small units")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Arma")]), _vm._v(" (It) – weapon")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Armata")]), _vm._v(" (It) – army, armed")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Artilleriysko-pulemetniy, AP")]), _vm._v(" (Ru) – artillery and machine gun")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Artilleriysko-pulemetniy Kaponir, APPK")]), _vm._v(" (Ru) – artillery and machine-gun caponier (APK) and half-caponier (APK), see ‘caponier’")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Artilerijski kazemate")]), _vm._v(" (Slov) – artillery casemate")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ase")]), _vm._v(" (Fin) – weapon")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ase, kivääri or tykki")]), _vm._v(" (Fin) – gun")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ase ja majoituskorsua")]), _vm._v(" (Fin) – weapons and accommodations bunker")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Asentamientos")]), _vm._v(" (Sp) – settlements, but also refers to military positions or military complexes")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Armén")]), _vm._v(" (Sw) – army")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Armerad betong or Förstärkt betong")]), _vm._v(" (Sw), Armeret beton, (Da) Armert betong (Nor) – reinforced concrete")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Avant-Cuirasse")]), _vm._v(" (F) – see glacis ring, usually referring to armour around a turret ring.")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Avant-Poste")]), _vm._v(" (F) – advanced post or outpost")]), _vm._v(" "), _c('p', {
    staticClass: "gloss-t"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Balcone")]), _vm._v(" (It) – balcony or gallery")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Baquette d’artillerie")]), _vm._v(" (F) – artillery ramparts")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Barbette mount")]), _vm._v(" – mounting that allows a weapon to fire over the rampart (en barbette) instead through an embrasure. The weapon is exposed, but has fewer restrictions on elevation and field of fire. Sometimes, the mount may include a gun shield. On ships, the term has a slightly different meaning")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Baterie")]), _vm._v(" (Cz) –, "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Baterija")]), _vm._v(" (Slov) – battery")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Battery")]), _vm._v(" – generally an artillery unit of two or more weapons")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Bâtiment")]), _vm._v(" (F) – building, warship")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Befehlsstand")]), _vm._v(" (G) – command post")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Belegeringsomwalling")]), _vm._v(" (D) – siege wall")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Beton")]), _vm._v(" (in most Latin, Germanic, Slavic languages and Magyar) – concrete")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Béton")]), _vm._v(" (F) – concrete")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Beton armat")]), _vm._v(" (Rom) – reinforced concrete")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Béton armé")]), _vm._v(" (F) – reinforced concrete")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Betongoverdekning")]), _vm._v(" – (Nor) concrete covering")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Betoni, Betonisia")]), _vm._v(" (Fin) – concrete")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Bétonné")]), _vm._v(" (F) – concrete, made of concrete")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Bewapening")]), _vm._v(" (D/Fl) – armament")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("BL")]), _vm._v(" – breech-loading gun")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Blockhouse")]), _vm._v(" – before the nineteenth century, referred to a wooden defensive building that served as a detached fort. After that, it included brick and concrete structures serving a similar purpose; by the twentieth century, many countries used the term to refer to bunkers serving a few men")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Blokhuis")]), _vm._v(" (D) – blockhouse")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Bolwerk")]), _vm._v(" (D) – stronghold, bastion or bulwark")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Borstwering")]), _vm._v(" (D/Fl) – parapet")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("BRO (batalionniy rajon oborony)")]), _vm._v(" (Ru) – Battalion Defence Area, the tactical element of URs")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Bronekolpak")]), _vm._v(" (Ru) – armoured domes")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Buitenwerk")]), _vm._v(" (D) – outwork")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Bunker")]), _vm._v(" – generic term that refers to any type of shelter or fortification made of wood, earth, concrete or metal that can be small enough for one or two men or large enough to house submarines")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Bunkernyy")]), _vm._v(" (Ru) – bunker or concrete structure "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not")]), _vm._v(" for weapons")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Bunkr (Cz), Bunkerja, (Slov), Bunkier (Pol), Bunkkeri")]), _vm._v(" (Fin) – bunker")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Bureau")]), _vm._v(" (F) – office")]), _vm._v(" "), _c('p', {
    staticClass: "gloss-t"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Calcestruzzo")]), _vm._v(" (It) – concrete")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Camp retrenché")]), _vm._v(" (F) – entrenched camps or fortified town")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cannon")]), _vm._v(" – generally, artillery piece that fires a projectile with a flat or low trajectory")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cannoniera")]), _vm._v(" (It) – embrasure")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cañón antitanque")]), _vm._v(" (Sp) – anti-tank cannon")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cañón de hierro entubado")]), _vm._v(" (Sp) – cast-iron cannon")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Capital")]), _vm._v(" (G) – an imaginary perpendicular line running from the centre gorge to the point of the bastion or salient at the front of a fort")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Caponier")]), _vm._v(" – a casemate projecting into the gorge or ditch of a fort that fires to both flanks. A reverse caponier fires to the rear or may face to the rear depending on the terminology of the country using the term. A full caponier is located to fire along both sides of a straight scarp wall; a double caponier is located in a salient with over 180° arc of fire; a half-caponier has an arc of fire of 90°. The term caponier (or Kaponir) and half-caponier in Russian and some East European fortifications often refers to an artillery casemate not in a moat that covers one or two flanks respectively")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Caposaldo")]), _vm._v(" (It) – stronghold")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Casamatta")]), _vm._v(" (It) – casemate")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Case-hardened or surfaced hardened steel")]), _vm._v(" – a process known as cementing that forms a thin hard outer layer over the softer thicker inner layer")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Casemate")]), _vm._v(" – bombproof fortification for weapons. In German a structure that gives enfilade fire")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Casemates: Delostrelecky srub, Pechotno srub")]), _vm._v(" (Cz); "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Artilerijski kazemate; Cazemata")]), _vm._v(" (Rom), "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Pehotni kazemat (Slov)")]), _vm._v(" – artillery casemate and infantry casemate. Also, see "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Kasametti")])]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Caserne")]), _vm._v(" (F) or "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Kaserne")]), _vm._v(" (G) – barracks")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cast iron")]), _vm._v(" – iron that is hard, brittle and more difficult to work with than wrought iron, which is more malleable; cast iron has more carbon than wrought iron, which makes it harder. It also contains more carbon than cast steel – see Steel Casting – pouring molten metal into a mould")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cave à canon")]), _vm._v(" (F) – in 1870s, it was a small blockhouse for one cannon, but by the twentieth century it became a more sturdy blockhouse for a cannon")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cazemata cu locas circular din beton")]), _vm._v(" (Rom) – Tobruk type position (circular concrete casemate)")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cement and Concrete")]), _vm._v(" – In 1834. Joseph Aspdin (1778–1855), a mason from Leeds, patented Portland cement (it looked like Portland stone). Concrete, which was invented by the ancient Romans, was used mainly for foundations in the nineteenth century. Portland cement made an effective mortar for concrete works. Newhaven Fort was the first modern fort to use concrete (for the scarp wall) using Captain H.R.D. Scott’s formula, which was not as strong as Portland cement")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chilled cast iron or Hartguß (Hartguss)")]), _vm._v(" – iron poured cold into a mould, which gives it greater strength; it was replaced by cast steel in the 1890s.")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cinta")]), _vm._v(" – (It, Sp) enceinte")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CKM – Ciężki karabin maszynowy")]), _vm._v(" (Pol) – heavy machine gun")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cloche")]), _vm._v(" (F) – non-rotating turret sometimes referred to as an armoured dome")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Coffre")]), _vm._v(" (F) – casemate-like position found in the counterscarp used to defend the bottom of the moat and linked to the main work by a tunnel")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Compound armoured plates")]), _vm._v(" – two narrowly connected plates, the outer one of which consist of hard brittle steel and the inner one of soft tough wrought iron. This did not prove to be a very successful combination.")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Concrete")]), _vm._v(" – mixture of cement and aggregate")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Contrescarpe à arceaux de décharge")]), _vm._v(" – (F), "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Dechargen-Kontrescarpe")]), _vm._v(" (G) – counterscarp with small arches that discharge or disperse the weight of the masonry of the wall above; the arches can also provide shelters for troops in the fossé during a bombardment; often used in nineteenth-century fortifications")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Corazatto")]), _vm._v(" (It) – armoured")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Counterscarp")]), _vm._v(" – the outside wall of a ditch or moat")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Countrescarpgalerij")]), _vm._v(" (D) – counterscarp gallery")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Countrescarpkoffer")]), _vm._v(" (D) – counterscarp casemate")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cuisine")]), _vm._v(" (F) – kitchen")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cupola")]), _vm._v(" – if armoured, it can refer to various types of turrets that rotate and/or retract. In French, non-moveable turrets are referred to as cloches to avoid confusion")]), _vm._v(" "), _c('p', {
    staticClass: "gloss-t"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Dækningsrum")]), _vm._v(" (Da), "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Deknings bunker")]), _vm._v(" (Nor, Sw) – troop shelter")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Dekningsrom")]), _vm._v(" (Nor) – dugout")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Dělo, kanón")]), _vm._v(" (Cz) – cannon")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Delostrelecky srub")]), _vm._v(" (Cz) – see "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("casemate")])]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Diamantgrav")]), _vm._v(" (Sw) – diamond fossé, sometimes water filled, designed to prevent the enemy from climbing out")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Dike")]), _vm._v(" (Sw) – ditch")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Doorgang")]), _vm._v(" (D/Flem) – passage")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Doppelter koffer")]), _vm._v(" (G) – Austrian term for double coffre (counterscarp casemate)")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("DOT (Dolgovremennaya Ognevaya Tochka)")]), _vm._v(" (Ru) – long-term firing point (post) built of concrete. In the West it would be called a combat bunker (bunkers in Soviet terms are not for weapons). Technically one weapon’s embrasure was for frontal fire as opposed to ‘kaponirs’ (caponiers) which give flanking fire")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Draaikoepel")]), _vm._v(" (D, Fl) – rotating turret")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Drehturm")]), _vm._v(" (G) – rotating turret")]), _vm._v(" "), _c('p', {
    staticClass: "gloss-t"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Einfacher Koffer")]), _vm._v(" (G) – Austrian term for a simple counterscarp casemate")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Einheitsfort")]), _vm._v(" (G) – term used by the Austrians for a ‘unit fort’, which generally implies a self-contained unit with infantry and artillery. These ‘unit forts’ resembled Brialmont’s Belgian forts with a casemated barrack block in the gorge, a gorge caponier and traditors (artillery casemates for flanking fire); if a line of armoured cupolas was present, they were classified as Panzerwerke. At the end of the century, the Austrians went to the Nahkampfwerke in the front line and the Fernkampfbatterie in positions behind it")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Eisen")]), _vm._v(" (G) – iron")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Enceinte")]), _vm._v(" (F) – a continuous line of fortification surrounding a city such as a city wall")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Entrée des Hommes")]), _vm._v(" (F) – personnel entrance")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Entrée des Munitions")]), _vm._v(" (F) – munitions entrance")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Erőd and kiserőd")]), _vm._v(" (Hun) – stronghold, fort or fortress, small fort")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Erődítésének")]), _vm._v(" (Hun) – fortifications")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Escarpe or scarp")]), _vm._v(" – inner wall of the fossé")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Expense magazine")]), _vm._v(" – British term. In America and some other countries identified as a ready magazine with ammunition ready for use near the gun")]), _vm._v(" "), _c('p', {
    staticClass: "gloss-t"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Face")]), _vm._v(" – sometimes called front, in a bastion it refers to the sides facing the enemy (left and right face). In a fort it is the same term, especially when two sides face the enemy and they meet to form an angle. Where the face meets a side, that side is called a flank or shoulder (left and right flank")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fæstning")]), _vm._v(" (Da) – "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Fästning")]), _vm._v(" (Sw) – "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Festning")]), _vm._v(" (Nor) fortress or fort")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fahrpanzer")]), _vm._v(" (G) – mobile armoured gun")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fast torn (Sw)")]), _vm._v(" – a cupola in the form of a non-rotating turret (cloche)")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fer")]), _vm._v(" (F) – iron")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Feritoia")]), _vm._v(" (It) – loophole, slit")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fernkampfbatterie")]), _vm._v(" (G) – Austrian term for a fort with cannons forming a battery position either in open emplacements or turrets; came into use in 1900")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ferroconcrete or reinforced concrete")]), _vm._v(" – concrete poured into a form containing iron or steel rods to make it more resistant to bombardment. It was invented in 1849 French gardener Joseph Monier (1823–1906)")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Feste (pl. Festen)")]), _vm._v(" (G) – originally fortress, but in the 1890s it referred to the new groups of armoured fortifications")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Festung")]), _vm._v(" (G) – fortress")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fonte dure (F)")]), _vm._v(" – hard cast iron")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Forged steel")]), _vm._v(" – whereas cast steel is poured, forged is hammered or pressed into shape by mechanical means that yield a stronger product")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Förläggning (Sw)")]), _vm._v(" – barracks or caserne")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Forging")]), _vm._v(" – beating metal into shape with a hammer or by mechanical means")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fort, Fortress")]), _vm._v(" – generally, size determines the difference; the fortress is the larger of the two, however, the two terms have been used interchangeably")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fort d’arrêt")]), _vm._v(" (F) – stop fort or barrier fort that blocks an avenue of advance")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Forten")]), _vm._v(" (D) – forts")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fortet")]), _vm._v(" (Da, Nor, Sw) – fort")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Forts de rideau/de liaison")]), _vm._v(" (F) – curtain forts")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fossato")]), _vm._v(" (It) – moat or ditch")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fossé")]), _vm._v(" (F) – ditch, ditch surrounding a fort like a moat. A diamond fossé is an angular ditch that is found in front of the embrasures and doors of many modern casemates")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fusil-Mitrailleur")]), _vm._v(" (F) – automatic rifle")]), _vm._v(" "), _c('p', {
    staticClass: "gloss-t"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Galerij and gang")]), _vm._v(" (D, Fl) – underground gallery and corridor")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Galleri")]), _vm._v(" (Da, Nor, Sw) – gallery")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Gang or Korridor")]), _vm._v(" (Da, Nor, Sw) – tunnel or corridor")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Gard (Rom)")]), _vm._v(" – fence or wall")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Gedetacheerde Reverscaponnier")]), _vm._v(" (Fl) – detached reverse caponier")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Génie (F)")]), _vm._v(" – military engineer")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Geppuska/nehézgéppuska/golyószóró")]), _vm._v(" (Hun) – heavy machine gun, light machine gun")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Geschützschartenstand")]), _vm._v(" (G) – forward-firing gun bunker")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Geschützkasematte")]), _vm._v(" (G) – artillery casemate")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Geschuttoren")]), _vm._v(" (D) – turret")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Geschützturm")]), _vm._v(" (G) – gun turret")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Gewapend beton")]), _vm._v(" (D/Fl) – reinforced concrete")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Gewehr")]), _vm._v(" (G) – gun")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Glacis")]), _vm._v(" – natural or man-made incline that slopes downward from the counterscarp")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Glacis ring/frontal armour")]), _vm._v(" – armour placed around the turret ring")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Glocke (G)")]), _vm._v(" – cloche, non-rotating steel dome")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Golyószóró")]), _vm._v(" (Hun) – light machine-gun")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Gorge")]), _vm._v(" – ditch on the rear of a fort (see throat)")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Graben")]), _vm._v(" (G) – ditch or moat")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Gracht")]), _vm._v(" (D/Fl) – canal")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Granatwerfer")]), _vm._v(" (G) – infantry mortars")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Grav")]), _vm._v(" (Da) – fossé or moat")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Gravkaponjär")]), _vm._v(" (Sw) – counterscarp casemate or ditch caponier")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Grensefestning")]), _vm._v(" (Nor) – border fortress")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Grille")]), _vm._v(" (F) – iron railing fence")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Grøft")]), _vm._v(" (Da, Nor) – ditch")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Gros")]), _vm._v(" (F) – large")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Grosso/a")]), _vm._v(" (It) – large")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Grüson chilled cast iron")]), _vm._v(" – made with a highly carbonized pig iron, known as white iron and a less carbonized soft grey iron. It was more resistant than the brittle steel plates of the 1860s and 1870s")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Gyalogsági óvóhely")]), _vm._v(" (Hun) – infantry shelter")]), _vm._v(" "), _c('p', {
    staticClass: "gloss-t"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Haer")]), _vm._v(" (Da, Nor) – army")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Half-caponier")]), _vm._v(" – a casemate the gorge or ditch of a fort that fires to one flank")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Harcálláspont, parancsnokság, PKI")]), _vm._v(" (Hun) – command post or HQ")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Harckocsi elleni gúlasor")]), _vm._v(" (Hun) – anti-tank obstacles")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Hartguß")]), _vm._v(" – chilled cast iron developed by Hermann Grüson")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Haubitze")]), _vm._v(" (G), "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Haubits")]), _vm._v(" (Dan, Nor, Sw), "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Haupitsi")]), _vm._v(" (Fin) – howitzer")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Haxo Casemate")]), _vm._v(" – freestanding masonry casemate on exposed sections of the parapet designed by French military engineer General François Haxo early in the nineteenth century; characterized by arched chambers, open rear, front wall covered by earth banks often with armoured embrasures")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Hefkopel")]), _vm._v(" (D) – retracting and rotating turret")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Hefkoepel")]), _vm._v(" (D, Fl) – retracting (lifting) turret")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Hindernis")]), _vm._v(" (D, Fl, G) – obstacle")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Höj och sänkbart")]), _vm._v(" (Sw) – disappearing turret")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Hoofdwal")]), _vm._v(" (D, Fl) – main wall")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Hoofdweerstandstelling")]), _vm._v(" (D, Fl) – main resistance position (outer ring of Antwerp) ")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Hormigón, hormigón armado")]), _vm._v(" (Sp) – concrete, reinforced concrete")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Houfnice")]), _vm._v(" (Cz), "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Havbice")]), _vm._v(" (Slov) – howitzer")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Houwits")]), _vm._v(" (D) – howitzer")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Howitzer")]), _vm._v(" – artillery piece that generally fires its projectile at a higher angle than a gun")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Hradní příkop")]), _vm._v(" (Cz) – moat, fossé")]), _vm._v(" "), _c('p', {
    staticClass: "gloss-t"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Imbocco")]), _vm._v(" (It) – entrance, inlet")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Infanteriställning")]), _vm._v(" (Sw) – regular or concrete trench or foxhole")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Insinööri")]), _vm._v(" (Fin) – engineer")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ijzer")]), _vm._v(" (D/Fl) – iron")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ingang")]), _vm._v(" (D, Fl, G) – entrance")]), _vm._v(" "), _c('p', {
    staticClass: "gloss-t"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Järn")]), _vm._v(" (Sw), Jern (Da, Nor) – iron")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Jeklena")]), _vm._v(" (Slov) – steel")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Jumelage de Mitrailleuses, JM")]), _vm._v(" (F) – twin machine gun")]), _vm._v(" "), _c('p', {
    staticClass: "gloss-t"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Kaivantopanssariestettä")]), _vm._v(" (Fin) – anti-tank trench")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Kampfstand")]), _vm._v(" (G) – combat bunker")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Kanonkelder")]), _vm._v(" (D, Fl) – underground chamber for preparation or storage of cannons")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Kanonstilling")]), _vm._v(" (Da, Nor) – gun position")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Kanuuna, tykki")]), _vm._v(" (Fin) – cannon")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Kasemat")]), _vm._v(" (Da), "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Kasematy")]), _vm._v(" (Cz), "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Kazemat")]), _vm._v(" (Slov), "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Kasematt")]), _vm._v(" (Nor, Sw), "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Kasematte")]), _vm._v(" (G), "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Kasematti")]), _vm._v(" (Fin), "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Kazamata")]), _vm._v(" (Pol) – casemate")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Keelfront")]), _vm._v(" – (D, Fl) gorge side, also called throat")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Kehlgraben")]), _vm._v(" (G) – gorge ditch")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Kehlkaserne")]), _vm._v(" (G) – gorge caserne (barracks)")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Kenttälinnoitteita")]), _vm._v(" (Fin) – field fortifications")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Keuken")]), _vm._v(" (D, Fl) – kitchen")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Kiviestattä, Kivieste")]), _vm._v(" (Fin) – stone barrier")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Kivipanssariestettä")]), _vm._v(" (Fin) – stone anti-tank obstacles")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Klok")]), _vm._v(" (D) – fixed turret, cloche")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Koepel")]), _vm._v(" (D/Fl) – cupola or turret")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Koffer")]), _vm._v(" (G) – counterscarp casemate; Austrians also use the term to refer to caponiers")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Konekivääri")]), _vm._v(" (Fin) – machine gun")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Konterskarpenkasematte")]), _vm._v(" (G) – counterscarp casemate")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Kopule")]), _vm._v(" (Cz), "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Fiksno Kupolo")]), _vm._v(" (Slov) – fixed turret, cloche or cupola")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Korsu")]), _vm._v(" (Fin) – wooden bunker, dugout or concrete bunker")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Kruitmagazijn")]), _vm._v(" (D, Fl) – powder magazine")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("K.u.K (Kaiserliches und Königliches Gemeinsames Heer)")]), _vm._v(" (G) – Imperial and Royal Common Army of Austria-Hungary")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Kulomet")]), _vm._v(" (Cz), "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Mitraljez")]), _vm._v(" (Slov) – machine gun")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Kuppel")]), _vm._v(" (Da), "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Kupol")]), _vm._v(" (Sw) – cupola")]), _vm._v(" "), _c('p', {
    staticClass: "gloss-t"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Laboratory")]), _vm._v(" – British term for rooms near the magazine where shells and cartridges were filled or emptied")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Laminated")]), _vm._v(" – two or more layers not made from a homogenous alloy. It could also include two differed types of metal or materials. The French term ‘laminé’ refers to ‘rolled’ iron or steel ")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Lance-Bombe, LB")]), _vm._v(" (F) – bomb thrower, a weapon that was between a mortar and howitzer")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Lance-Grenade, LG")]), _vm._v(" (F) – grenade thrower")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Landwehr")]), _vm._v(" (G) – Austrian territorial troops")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Lehky Objekt")]), _vm._v(" (Cz) – bunker or light defensive structure")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Lemn")]), _vm._v(" (Rom) – wood")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Linnake")]), _vm._v(" (Fin) – fort")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Linnoitteita")]), _vm._v(" (Fin) – fortifications or fortify")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Linnoitus")]), _vm._v(" (Fin) – fortress")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Lyddite")]), _vm._v(" – see Appendix II")]), _vm._v(" "), _c('p', {
    staticClass: "gloss-t"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Machinegeweer, mitrailleuse, flets")]), _vm._v(" (D) – machine gun")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Main d’Oeuvre Militaire, MOM")]), _vm._v(" (F) – military manpower")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Malloppo")]), _vm._v(" (It) – exposed or partially buried bombproof concrete construction that houses a weapon casemate, an observatory or the entrance to a fortified structure; can also be referred to as a block")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Maschera anti-gas")]), _vm._v(" (It) – gas mask")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Maskingevaer")]), _vm._v(" (Nor), "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Maskingevär")]), _vm._v(" (Sw), "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Maskinpistol")]), _vm._v(" (Da, Nor) – machine gun")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MG-Schartenstand")]), _vm._v(" (G) – forward-firing machine-gun bunker")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Melinite")]), _vm._v(" – see Lyddite")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Metsel")]), _vm._v(" (D, Fl) – masonry (stone or brick) work")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Miinakenttä")]), _vm._v(" (Fin), "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Minfält")]), _vm._v(" (Sw), "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Mineflet")]), _vm._v(" (Da, Nor), "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Mijnenveld")]), _vm._v(" (D) – minefield")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Militæringeniør")]), _vm._v(" (Da, Nor), "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Militäringenjör")]), _vm._v(" (Sw) – military engineer")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MINA")]), _vm._v(" (Ru) – acronym referring to a complex of DOTs linked with tunnels with underground facilities")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Mine, minefield")]), _vm._v(" – initially, a mine was a tunnel with a chamber that was used to undermine a fortification. With the advent of gunpowder, containers filled with explosives were placed in the ground or water to explode on contact or by remote detonation to inflict casualties, destroy or damage vehicles or ships. Early minefields actually consisted of a series of pits with stakes covered with brush. The use of explosive containers eventually led to the creation of modern minefields")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Minimalscharten")]), _vm._v(" (G) – armoured embrasure with a pivot for the gun near the opening to increase the field of fire with a small embrasure")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Minomet")]), _vm._v(" (Cz) – mortar")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Minové")]), _vm._v(" (Cz) – mines")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Minové pole")]), _vm._v(" (Cz) – minefield")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Mitragliatrice")]), _vm._v(" (It) – machine gun")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Mitrailleuse")]), _vm._v(" (F) – machine gun")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Mitraliera")]), _vm._v(" (Rom) – machine gun")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Mítralieră uşoară")]), _vm._v(" (Rom) – light machine gun")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Moat")]), _vm._v(" – ditch that generally surrounds part or all of a fortification and may or may not be water-filled")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Monte-Charge")]), _vm._v(" (F) – type of lift used for taking ammunition from a lower level to the guns of a fortification; can be as large as a standard elevator or small enough to just carry boxes of artillery rounds or individual rounds")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Mörser")]), _vm._v(" (G) – heavy mortar, often listed as a howitzer")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Mörssäri, krnaatinheitin")]), _vm._v(" (Fin) – mortar")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Mortar")]), _vm._v(" – weapon that fires a projectile at a high trajectory")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Moskit (Ru) – mosquito")]), _vm._v(" – refers to small machine-gun posts in secondary sectors")]), _vm._v(" "), _c('p', {
    staticClass: "gloss-t"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Nahkampfwerk")]), _vm._v(" (G) – Austrian for fort with infantry positions, usually with howitzer turrets for close defensive fire")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Nehézpuska")]), _vm._v(" (Hun) – anti-tank rifle")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Nido")]), _vm._v(" (Sp) – nest, i.e. machine-gun bunker or other combat position")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Noyau")]), _vm._v(" (G) – in Austrian fortifications refers to the defence of the core, i.e. the enceinte around a fortress")]), _vm._v(" "), _c('p', {
    staticClass: "gloss-t"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Obice")]), _vm._v(" (It) – howitzer")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Object, objekt")]), _vm._v(" – vague generic term, in many Slavic languages also used to designate a range of structures from a small bunker to a fort"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn-1",
      "id": "fn-1"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Observationstaarn")]), _vm._v(" (Da) – observation cloche")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ocel")]), _vm._v(" (Cz), "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Jeklena")]), _vm._v(" (Slov) – steel")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Oja")]), _vm._v(" (Fin) – ditch")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Omwalling")]), _vm._v(" (D, Fl) – rampart, wall or enclosure")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Opera/e")]), _vm._v(" (It) – work(s) or fortification(s)")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Opornye Punkty")]), _vm._v(" (Ru) – strongpoints")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Otocna vez")]), _vm._v(" (Cz) – rotating turret")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ouvrage")]), _vm._v(" (F) – work, fort; from 1871 to 1914 generally referred to an infantry earthwork and sometimes to a smaller fort in the intervals. In the 1930s, it was used for the new type of forts found in the Maginot Line. The term is often translated as ‘fort’"), _c('s', [_c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn-2",
      "id": "fn-2"
    }
  }, [_vm._v("2")])])])]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Overbanks")]), _vm._v(" (Fl) – artillery firing over the ramparts (en barbette) rather than through an embrasure")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Óvóhely")]), _vm._v(" (Hun) – shelter, bunker or dugout")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("OW, Obszar warowny")]), _vm._v(" (Pol) – fortified district")]), _vm._v(" "), _c('p', {
    staticClass: "gloss-t"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Pak-Schartenstand")]), _vm._v(" (G) – forward-firing anti-tank (PAK) gun bunker")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Pallokorsua")]), _vm._v(" (Fin) – ‘ball’ bunkers")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Pancéřování")]), _vm._v(" (Cz) – armour")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Páncéltörő ágyú")]), _vm._v(" (Hun) – anti-tank gun")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Pansertåarn")]), _vm._v(" (Da, Nor), "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Pansartorn")]), _vm._v(" (Sw) – armoured turret")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Panssari, panssarilevy")]), _vm._v(" (Fin) – armour")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Panssarintorjuntatykki")]), _vm._v(" (Fin) – anti-tank")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Pantser")]), _vm._v(" (D, Fl) – armour")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Pantseraffuit")]), _vm._v(" (D, Fl) – armoured carriage that is a special turret, which lifts up over the forward armour to rotate")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Pantserkoepel")]), _vm._v(" (D, Fl) – armoured turret")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Parc d’Artillerie")]), _vm._v(" (F) – artillery park, a site with several warehouses; often an arsenal to repair weapons")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Panzer")]), _vm._v(" (G) – armour")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Panzerkuppel")]), _vm._v(" (G) – armoured cupola")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Panzertürme")]), _vm._v(" (G) – armoured cloche")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Panzerwerk")]), _vm._v(" (G) – 1939 term for bunker with walls a minimum of 1.0m thick; group of two or more of these bunkers")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Patteri")]), _vm._v(" (Fin) – battery")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Pĕchotní srub")]), _vm._v(" (Cz), "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Pehotni kazemat")]), _vm._v(" (Slov) infantry casemate")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Pevnost")]), _vm._v(" (Cz), "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Utrdba")]), _vm._v(" (Slov) – fort or fortress")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Pevnůstek")]), _vm._v(" (Cz) – redoubt, blockhouse")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Pevnustka")]), _vm._v(" (Cz) – blockhouse")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Pezzo")]), _vm._v(" (It) – piece")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Piastrone corrazatto")]), _vm._v(" (It) – large armoured plate")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Piazzaforte")]), _vm._v(" (It) – fortress, fortified town, stronghold")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Pigtråd")]), _vm._v(" (Da), "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Piggtråd")]), _vm._v(" (Nor), "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Taggtråd")]), _vm._v(" (Sw) – barbed wire")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Pigtråd Nett")]), _vm._v(" (Da), "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Piggtradnett")]), _vm._v(" (Nor) – barbed-wire network")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Piikkilankaestettä")]), _vm._v(" (Fin) – barbed-wire obstacle")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Pistolet lance-fusée")]), _vm._v(" (F) – flare gun")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Pjäs")]), _vm._v(" (Sw) – cannon")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Place d’armes")]), _vm._v(" (F) – assembly point for troops, parade ground")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Place forte")]), _vm._v(" (F) – stronghold or fortress")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Pont")]), _vm._v(" (F) – bridge")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Pont mobile")]), _vm._v(" (F) – drawbridge")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Pont roulant")]), _vm._v(" (F) – rolling bridge that slides into a wall")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Postavení")]), _vm._v(" (Cz) – position")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Příkop")]), _vm._v(" (Cz) – ditch")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Progettazione")]), _vm._v(" (It) – design")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Proiettile")]), _vm._v(" (It) – bullet or projectile")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Protezione")]), _vm._v(" (It) – protection")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Protitanková")]), _vm._v(" (Cz), "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Protitank")]), _vm._v(" (Slov) – anti-tank")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Puesto de Mando")]), _vm._v(" (Sp) – command post")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Puisia kenttälinnoitteita")]), _vm._v(" (Fin) – wooden field fortifications")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Puskové granátomety, Puška granátomet")]), _vm._v(" (Cz) – rifle grenade launcher")]), _vm._v(" "), _c('p', {
    staticClass: "gloss-t"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Quadrilateral")]), _vm._v(" – four-sided fortifications; this does not mean the sides, especially the gorge, are straight. The term trapezoid describes many forts with two "), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }), _vm._v("parallel sides and rhombus and kite for four sided forts with a diamond or kite shape. Square and rectangular forts are more regularly shaped quadrilateral pre-nineteenth century forts")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Racer, racer track")]), _vm._v(" – a curved track in the emplacement that allowed the guns to traverse quickly")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("RBL")]), _vm._v(" – rifled breech-loading gun.")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("RE")]), _vm._v(" – British Royal Engineers")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Redan")]), _vm._v(" – work with two faces forming a salient angle or a triangular work in front of the main line")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Redoubt")]), _vm._v(" – independent outwork, often square or polygonal")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Reduit")]), _vm._v(" – a fortified position like a medieval keep (donjon) or citadel; last-stand position in a fortification in the nineteenth century that the high-explosive shell of the 1880s made obsolete")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Retrocarica, Ret.")]), _vm._v(" (It) – breech-loader")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Reverse caponier")]), _vm._v(" – caponier on the counterscarp; often found in front of a fort; same as coffre")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Reverse Kaponniere")]), _vm._v(" (G) – reverse caponier")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Revetment")]), _vm._v(" – retaining wall along a ditch")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Revolverová hlavice")]), _vm._v(" (Cz) – revolving turret")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ricovero truppa")]), _vm._v(" (It) – troop shelter")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Rideau défensif")]), _vm._v(" (F) – defensive curtain")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ridotto")]), _vm._v(" (It) – reduit")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Riegel")]), _vm._v(" (G) – switch line, defensive position that is oblique to the front and connects to other defensive position in order to prevent hostile penetrations from being exploited to the flanks")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Rigata")]), _vm._v(" (It) – rifling")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Rinneleikkausta")]), _vm._v(" (Fin) – cutting a steep slope into the terrain to form an anti-tank barrier")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Riservetta")]), _vm._v(" (It) – ammunition storage room of a fortification")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("RML")]), _vm._v(" – rifled muzzle-loading gun")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Rolled iron and steel")]), _vm._v(" – a process where the metal is passed through rollers, reducing its thickness and producing sheets, bars or some other form. There are both hot and cold rolling, the latter is done at normal room temperature. Rolled wrought iron is wrought iron broken up and reheated to create a higher quality of wrought iron. Cold rolled steel is stronger by about 20 per cent while hot rolled is more malleable. Hot rolled steel can be used to produce sheet metal")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Rörlight torn")]), _vm._v(" (Sw) – rotating turret")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Rów przeciwpancerny")]), _vm._v(" (Pol) – anti-tank ditch")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Rustning, Pansar")]), _vm._v(" (Da, Sw) – armour")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ryggkaponjör")]), _vm._v(" (Sw) – gorge caponier")]), _vm._v(" "), _c('p', {
    staticClass: "gloss-t"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Salient")]), _vm._v(" – angle of the outward projecting end of a bastion; ravelin or another type of fortification")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Samengevoegde Caponnieres")]), _vm._v(" (Fl) – double caponier (casemate positions on two sides)")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Sant anticar")]), _vm._v(" (Rom) – anti-tank ditch")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Sapper")]), _vm._v(" – from French sappe or trench – originally referred solely to the people who dug trenches and tunnels (saps in siege warfare); later applied to combat engineers (in some armies called ‘pioneers’) in general")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Sbarramento")]), _vm._v(" (It) – barrage, barrier")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Scarp")]), _vm._v(" – the inside wall of a ditch or moat")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Schanze")]), _vm._v(" (G) – independent fortification, often a small earthen fortification to protect artillery pieces")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Schartenmauer")]), _vm._v(" (G) – wall with embrasures or loopholes")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Schartenstand")]), _vm._v(" (G) – forward firing MG or AT gun bunker")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Schietgat")]), _vm._v(" (D, Fl) – embrasure or loophole")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Schirmlafette")]), _vm._v(" (G) – armoured shield or housing mount")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Schron")]), _vm._v(" (Pol) – shelter, but can also refer to a bunker or casemate")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Schuilkelder")]), _vm._v(" (D) – shelter or dugout")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Schulterflankenkasematter")]), _vm._v(" (G) – shoulder casemate (casemate on a flank)")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Settore")]), _vm._v(" (It) – sector")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Självsänkande lavettage")]), _vm._v(" (Sw) – self-lowering carriage i.e. disappearing gun")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Skans")]), _vm._v(" (Sw) – redoubt or small fort")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Skupina Trvrí")]), _vm._v(" (Cz) – fortress group")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Skyddsrom")]), _vm._v(" (Sw) – dugout")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Skyttegrav")]), _vm._v(" (Da, Nor) – fighting trench")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Skyttergrav")]), _vm._v(" (Nor) – fighting trench")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Sloot")]), _vm._v(" (D) – ditch")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Slotgracht")]), _vm._v(" (D) – moat")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Sperre")]), _vm._v(" (G) – barrier, barrier fort that blocks access")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Spessore")]), _vm._v(" (It) – thickness")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Spitzenflankenkasematte")]), _vm._v(" (G) – salient counterscarp casemate")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Srub")]), _vm._v(" (Cz) – casemate, blockhouse")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Staal")]), _vm._v(" (D, Fl) – steel")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Stahlbeton, Eisenbeton")]), _vm._v(" (G) – reinforced concrete")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Stål")]), _vm._v(" (Da, Nor, Sw) – steel")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Steel")]), _vm._v(" – iron ore converted to a metal with a different process than iron, contains various alloys such as manganese, titanium, copper, chromium and/or nickel to add strength and/or flexibility. Before the alloys can be added, the iron ore must be processed to reduce the amount of carbon in the iron to required levels")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Stena")]), _vm._v(" (Cz) – wall")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Stěna se střílnou")]), _vm._v(" (Cz) – wall with loophole")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Stormhinder")]), _vm._v(" (Sw) – assault barrier such as barbed wire entanglements")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Střílna")]), _vm._v(" (Cz) – loophole, crenel")]), _vm._v(" "), _c('p', {
    staticClass: "gloss-t"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Taarn")]), _vm._v(" (Nor) – fixed turret, cloche")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Tackta pjasvarn")]), _vm._v(" (Sw) – casemate")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Taggtråd")]), _vm._v(" (Sw) – barbed wire")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Tagliata")]), _vm._v(" (It) – fortified position that cuts off a passage, i.e. a roadblock")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Tähystysauicdo")]), _vm._v(" (Fin) – observation cloche")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Tambour")]), _vm._v(" (G) – place d’armes")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Tårn")]), _vm._v(" (Da) – fixed turret or tower")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Tårn Kanonene")]), _vm._v(" – (Nor) turret cannon")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Teräs")]), _vm._v(" (Fin) – steel")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Teräsbetoni")]), _vm._v(" (Fin) – steel reinforced concrete.")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Těžký kulomet")]), _vm._v(" (Cz) – heavy MG")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Throat")]), _vm._v(" – ‘gorge’ in Germanic and Slavic languages")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Torn")]), _vm._v(" (Sw) – turret")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Torni")]), _vm._v(" (Fin) – turret")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Torpedo")]), _vm._v(" – term for both submarine mines (as opposed to land mines) and an explosive container with locomotion. After 1870, they were listed as mines and torpedoes")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xix"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Tourelle Blindée")]), _vm._v(" (F) – armoured turret, first developed in the late nineteenth century; rotates and sometimes eclipses")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Traditor Battery")]), _vm._v(" – from Italian traitor; used in French, German and Italian and French to describe an artillery casemate or battery that provides fire to the flanks and rear")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Tradytor")]), _vm._v(" (Pol) – similar to a caponier, in modern terminology an artillery casemate designed for flanking fire")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Tragere de Front")]), _vm._v(" (Rom) – firing to the front")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Trap")]), _vm._v(" (D, Fl) – stairs")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Trapezoidal forts")]), _vm._v(" – see Quadrilaterals")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Traversa")]), _vm._v(" (It) – traverse, cross piece")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Trouée")]), _vm._v(" (F) – gap")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Tubazione")]), _vm._v(" (It) – pipelines")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Tun anti-tank")]), _vm._v(" (Rom) – anti-tank cannon")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Turm")]), _vm._v(" (G) – tower if not armoured, turret")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Turret")]), _vm._v(" – tower (in older fortifications), small tower on a tower; in the nineteenth century, a metal structure that can rotate and mount a weapon; later, turret that could retract into the ground; also cupola")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Turret")]), _vm._v(" (Nor) – fixed turret or tower")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Tvrz, tvrze pl.")]), _vm._v(" (Cz) – fortress or fort")]), _vm._v(" "), _c('p', {
    staticClass: "gloss-t"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ukreplenniy Rayon, UR")]), _vm._v(" (Ru) – fortified region")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Umwallung")]), _vm._v(" (G) – enceinte")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Unterstand")]), _vm._v(" (G) – shelter, similar to the French abri")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Upravlenie Ingenerov")]), _vm._v(" (Ru) – Directorate of Engineers")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Usine")]), _vm._v(" (F) – engine room, powerhouse in a fortification")]), _vm._v(" "), _c('p', {
    staticClass: "gloss-t"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Vallgrav")]), _vm._v(" (Sw) – moat")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Vallihauta")]), _vm._v(" (Fin) – moat")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Värn")]), _vm._v(" (Sw) – bunker or dugout")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Vasbeton")]), _vm._v(" (Hun) – reinforced concrete")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Vashbeton raktár")]), _vm._v(" (Hun) – reinforced concrete magazine")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Våt Grav")]), _vm._v(" (Sw) – wet moat or fossé")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ventilazione")]), _vm._v(" (It) – ventilation")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Verschanst Kamp")]), _vm._v(" (D, Fl) – entrenched camp")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Verschwindturm")]), _vm._v(" (G) – disappearing turret")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Vesting")]), _vm._v(" (D, Fl) – fort or fortress")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Věžička, vížka")]), _vm._v(" (Cz) – turret")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Vieux fort")]), _vm._v(" (F) – old fort")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Vojenský inženýr")]), _vm._v(" (Cz) – military engineer")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Voldgrav")]), _vm._v(" (Da) – moat")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Voolgrav")]), _vm._v(" (Nor) – moat")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Vorratsräume")]), _vm._v(" (G) – store room")]), _vm._v(" "), _c('p', {
    staticClass: "gloss-t"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Wal")]), _vm._v(" (D, Fl) – rampart, wall")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Werkgruppe, Werkgruppen (pl.)")]), _vm._v(" (G) – modern fortification usually consisting of two or more positions linked together"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn-3",
      "id": "fn-3"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "gloss-t"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Wrought iron")]), _vm._v(" – iron with very low carbon content, tough, malleable, easily welded, corrosion resistant")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xx"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "gloss-t"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Żelbetowy")]), _vm._v(" (Pol) – reinforced concrete")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Żelazo")]), _vm._v(" (Pol) – iron")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Železo")]), _vm._v(" (Cz, Slov) – iron")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Železobeton")]), _vm._v(" (Cz, Slov) – ferroconcrete or reinforced concrete")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Zhelezobetonniy pulemetniy kolpak, ZhBOT")]), _vm._v(" (Ru) – ferroconcrete machine-gun dome")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Zijfront")]), _vm._v(" (D, Fl) – side front between front and rear")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Zvon")]), _vm._v(" (Cz) – cloche")]), _vm._v(" "), _c('p', {
    staticClass: "gloss-t"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Greek Terms")])]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Oλμoβoλεíα")]), _vm._v(" (Antiarmatiká) – anti-tank")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Avτiαερoπoρiκa")]), _vm._v(" (Antiaeroporiká) – anti-aircraft")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Kεvτρiκή Eπiτρoπή Oχυρóώσεων")]), _vm._v(" (Kentrikí Epitropí Ochyróseon or KEO) – Central Fortification Committee")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Koviάματα")]), _vm._v(" (Koniámata) – mortar")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Θωρὰκσης")]), _vm._v(" (Thorákisis) – armour")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Oχυρó")]), _vm._v(" (Ochyró) – fort")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Oχυρωματiκής Γραμμής")]), _vm._v(" (Ochyromatikís Grammís) – fortification line")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("пoλμβóλo")]), _vm._v(" (Polyvólo) – machine gun")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Yπóγεiα")]), _vm._v(" (ypógeia) – underground, subterranean")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0xx-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("San Marcos Fort – Errenteria. Open in high season: Wednesday to Sunday 10:00–14:00/16:00–18:00. Self-guided and guided tours are free. More info: 0034 943 494 521 / "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "mailto:turismoa@oarsoaldea.eus”turismoa@oarsoaldea.eus"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("mailto:turismoa@oarsoaldea.eus”turismoa@oarsoaldea.eus")])])]), _vm._v(" / "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.oarsoaldeaturismoa.eus",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.oarsoaldeaturismoa.eus")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "footnotet"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn-1",
      "id": "rfn-1"
    }
  }, [_vm._v("1")]), _vm._v(". The Slavic term for object, the Germanic and French term for work (Werk and ouvrage) are often loosely used for any type of position depending on its size.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn-2",
      "id": "rfn-2"
    }
  }, [_vm._v("2")]), _vm._v(". See Note 1.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn-3",
      "id": "rfn-3"
    }
  }, [_vm._v("3")]), _vm._v(". See Note 1.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35503469","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Glossary.vue
// module id = 75
// module chunks = 0